export function filterOutDuplicatedCitations(citations) {
    const citationUris = new Set();
    return citations.filter((citation) => {
        const isCitationUriUnique = !citationUris.has(citation.uri);
        if (isCitationUriUnique) {
            citationUris.add(citation.uri);
        }
        return isCitationUriUnique;
    });
}
